import React from 'react';
import {Box, Typography} from '@mui/material';
import TileInfo from './AurTileInfo';
import {t} from 'i18next';
import {getUTCDateTimeForDisplay} from '../../utils/utils';
import {ONLY_DATE_SHOW_FORMAT} from '../../constants/constants';
import {AurLightTooltip} from '../common/aur-light-tooltip/aur-light-tooltip';

interface DetailsContentProps {
  description: string;
  lastEditedBy: string;
  lastEditedDate: string;
}

const AurDetailsContent: React.FC<DetailsContentProps> = ({
  description,
  lastEditedBy,
  lastEditedDate,
}) => {
  const formattedLastEditedBy =
    lastEditedBy === '00000000-0000-0000-0000-000000000000' ||
    lastEditedBy === '-1'
      ? t('clientDetailsPage.managedropDown.system')
      : lastEditedBy; //replace empty guid and -1 by System

  return (
    <Box>
      <TileInfo
        label={t('addEditTeamMember.form.description')}
        value={description}
      />
      <Box className="client-accordion-details-footer">
        <Typography
          variant="caption"
          display="block"
          className="last-edited-text"
          data-testid="aur-details-content-last-edit-on"
        >
          {t('addEditTeamMember.form.lastEditedBy', {
            name: formattedLastEditedBy,
          })}
          <AurLightTooltip title={t('common.yearMonthDate')}>
            <span>
              {getUTCDateTimeForDisplay(lastEditedDate, ONLY_DATE_SHOW_FORMAT)}
            </span>
          </AurLightTooltip>
        </Typography>
      </Box>
    </Box>
  );
};

export default AurDetailsContent;
